__turbopack_context__.v({
  "container": "SecureTransactionBadge-module-scss-module__M9Gv-W__container",
  "header": "SecureTransactionBadge-module-scss-module__M9Gv-W__header",
  "notice": "SecureTransactionBadge-module-scss-module__M9Gv-W__notice",
  "text": "SecureTransactionBadge-module-scss-module__M9Gv-W__text",
});
